import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
} from '@mui/material';
import { Delete } from '@mui/icons-material';

const ConversationDialog = ({
  open,
  onClose,
  isAddingConversation,
  newConversation,
  setNewConversation,
  selectedConversations,
  handleAddConversation,
  handleDeleteConversation, // Ensure this function is passed as a prop
}) => {

  const handleDelete = async (id) => {
    console.log('deleting conversations with customerId: '+isAddingConversation[1])
    handleDeleteConversation(id, isAddingConversation[1])
  };

  const handleAdd = () => {
    console.log('handle add with customer id ' + isAddingConversation[1]);
    handleAddConversation(isAddingConversation[1]);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>{isAddingConversation[0] ? 'Add Conversation' : 'Conversations'}</DialogTitle>

      {isAddingConversation[0] ? (
        <DialogContent>
          <TextField
            label="Title"
            variant="outlined"
            fullWidth
            value={newConversation.title}
            onChange={(e) => setNewConversation({ ...newConversation, title: e.target.value })}
            style={{ marginBottom: '20px' }}
          />
          <TextField
            label="Conversation Text"
            variant="outlined"
            fullWidth
            multiline
            rows={4}
            value={newConversation.conversationText}
            onChange={(e) =>
              setNewConversation({ ...newConversation, conversationText: e.target.value })
            }
            style={{ marginBottom: '20px' }}
          />
          <TextField
            label="STResource"
            variant="outlined"
            fullWidth
            value={newConversation.STResource}
            onChange={(e) => setNewConversation({ ...newConversation, STResource: e.target.value })}
            style={{ marginBottom: '20px' }}
          />
        </DialogContent>
      ) : (
        <DialogContent>
          {selectedConversations.length > 0 ? (
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>ID</TableCell>
                    <TableCell>Title</TableCell>
                    <TableCell>Conversation Text</TableCell>
                    <TableCell>STResource</TableCell>
                    <TableCell>Date</TableCell>
                    <TableCell>Time</TableCell>
                    <TableCell>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {selectedConversations.map((conversation, index) => (
                    <TableRow key={index}>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{conversation.title}</TableCell>
                      <TableCell>{conversation.conversationText}</TableCell>
                      <TableCell>{conversation.STResource}</TableCell>
                      <TableCell>{new Date(conversation.date).toISOString().split('T')[0]}</TableCell>
                      <TableCell>{conversation.time}</TableCell>
                      <TableCell>
                        <IconButton
                          onClick={() => handleDelete(conversation._id)}
                          color="secondary"
                        >
                          <Delete />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Typography>No conversations found.</Typography>
          )}
        </DialogContent>
      )}

      <DialogActions>
        {isAddingConversation[0] ? (
          <Button onClick={handleAdd} color="primary">
            Add Conversation
          </Button>
        ) : null}
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConversationDialog;
